import React, { Suspense } from "react"
import { Route } from "react-router-dom"
import Loader from "../../Pages/Components/loader"

export default ({ path, component }) => (
  <Suspense fallback={<Loader />}>
    <Route path={path} component={component} />
  </Suspense>
)
